@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

// Arrow is the same color regardless of the state of SingleSelect
$arrow-down-svg-gray: url('../../styling/svg/ChevronDownGray.svg');
$arrow-up-svg-gray: url('../../styling/svg/ChevronUpGray.svg');
$arrow-down-svg-white: url('../../styling/svg/ChevronDownWhite.svg');

.SingleSelect {
  @extend %form-control-border;
  @extend %form-control-font;
  @extend %form-control-background;
  @extend %form-control-dropdown-disabled;
  @extend %form-control-select;

  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  width: 100%;
  color: $theme-color-dropdown;

  &.ArrowDown {
    background-image: $arrow-down-svg-gray;
    background-size: 17px;

    path {
      fill: $color-grey-A;
    }
  }

  &.ArrowUp {
    background-image: $arrow-up-svg-gray;
    background-size: 17px;
  }

  .Option {
    // styles font color of options
    color: $theme-color-text;
    font-weight: $font-weight-semibold;
    background-color: $theme-dropdown-background-color;
  }

  .option {
    // AUB-10639 defines color to work in Windows browsers
    color: $theme-color-text;
  }

  &:hover:enabled,
  &:focus:enabled {
    @extend %hover-focus-shadow;
  }

  &.isHighlighted {
    background-color: $theme-dropdown-selected-background-color;
    border-color: $theme-dropdown-selected-outline-color;
    border-width: 2px;
  }

  &.isErrored {
    border-color: $color-alert-red-border;
  }

  &.isSolid {
    color: $color-white;
    background-image: $arrow-down-svg-white;
    background-size: 17px;
    background-color: $form-control-color;

    &:hover,
    &:active,
    &:focus {
      outline: none;
      border: 1px solid $form-control-color-hover;
      background-image:
        $arrow-down-svg-white,
        linear-gradient(to left, $form-control-color-hover 0%, $form-control-color-hover 100%);
    }

    &:disabled,
    &[disabled] {
      color: $color-white;
      background-image: $arrow-down-svg-white;
      border: 1px solid $color-grey-A;
    }
  }
}

.InvalidInfo {
  padding-top: 0.25em;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 0.5em;
  white-space: pre-line;
  color: $color-alert-red-border;

  p {
    color: $color-alert-red-border;
    font-size: $font-size-normal;
    font-weight: $font-weight-semibold;
  }
}
